import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-authenticator-app-links',
    templateUrl: './authenticator-app-links.component.html',
    styleUrls: ['./authenticator-app-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuthenticatorAppLinksComponent {
    @Input() compact = false;
}
